import React, { useState } from 'react';
import s from '../styles/DownloadReport.module.css';  // Можно подключить стили

const DownloadReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('excel/api/export/vehicles', {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Ошибка загрузки отчета');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'vehicles_report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.container}>
      <button onClick={handleDownload} className={s.downloadButton} disabled={loading}>
        {loading ? 'Скачивание...' : 'Скачать отчёт в Excel'}
      </button>
      {error && <p className={s.error}>{error}</p>}
    </div>
  );
};

export default DownloadReport;
